import { render, staticRenderFns } from "./PlanBillingSettings.vue?vue&type=template&id=4512610b&"
import script from "./PlanBillingSettings.vue?vue&type=script&lang=js&"
export * from "./PlanBillingSettings.vue?vue&type=script&lang=js&"
import style0 from "./PlanBillingSettings.vue?vue&type=style&index=0&id=4512610b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports